import React from 'react';
import { Result, Row } from 'antd';
import { LockOutlined } from '@ant-design/icons';

const NoPermission = () => (
  <Row justify="center" align="middle" style={{ width: '100%', height: '100%' }}>
    <Result
      icon={<LockOutlined />}
      title="Usted no tiene los permisos para realizar este paso"
    />
  </Row>
);

export default NoPermission;
